import { dashboardDetailsService } from "../service";
import {
  setDashboardDetailsLoading,
  setDashboardDetailsInventoryData,
  setDashboardDetailsInventoryResponseData,
  setDashboardDetailsEvaluationData,
  setDashboardDetailsEvaluationConfirmData,
  setDashboardDetailsEvaluationResponseData,
  setDashboardDetailsFollowupData,
  setDashboardDetailsFollowupResponseData,
  setDashboardDetailsError,
  setDashboardDetailsInventoryChecklistData,
  setDashboardDetailsInventoryPartialAnswersData,
  setDashboardDetailsEvaluationPartialAnswersData,
  setDashboardDetailsFollowupPartialAnswersData,
} from "../slice/dashboardDetailsSlice";
import { toast } from "react-toastify";

const getInventoryDetailsAsync = (inventory_id,t) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getInventoryDetails(inventory_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsInventoryData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const addInventoryAnswerAsync = (inventory_id, data,t, navigate) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.addInventoryAnswer(inventory_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      navigate(`/participants/inventories/${inventory_id}/results`, { replace: true })
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false;
  }
};

const getInventoryResultsAsync = (inventory_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsInventoryResponseData({}));
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getInventoryAnswer(inventory_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsInventoryResponseData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const getEvaluationDetailsAsync = (workshop_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsEvaluationData({}));
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getEvaluationDetails(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsEvaluationData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const addEvaluationAnswerAsync = (workshop_id, data,t, navigate) => async (dispatch) => {
  
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.addEvaluationAnswer(workshop_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      //window.location.reload();
    } else {
      navigate(`/participants/evaluations/${workshop_id}/results`, { replace: true })
      dispatch(setDashboardDetailsEvaluationConfirmData({}))
       dispatch(setDashboardDetailsEvaluationData({}));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const getEvaluationResultsAsync = (workshop_id,t) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getEvaluationAnswer(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsEvaluationResponseData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const getFollowupDetailsAsync = (followup_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsFollowupData({}));
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getFollowupDetails(followup_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsFollowupData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const addFollowupAnswerAsync = (followup_id, data,t, navigate) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.addFollowupAnswer(followup_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      navigate(`/participants/followups/${followup_id}/results`, { replace: true })
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false;
  }
};

const getFollowupResultsAsync = (followup_id,t) => async (dispatch) => {
  
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getFollowupAnswer(followup_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsFollowupResponseData(response));
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};


const updateInventoryChecklistAsync = (inventory_id, data,t) => async (dispatch) => {

  try {
    const response = await dashboardDetailsService.updateInventorychecklist(inventory_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
    } else {
      dispatch(setDashboardDetailsError({}));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
  }
};

const addInventoryStepsAsync = (inventory_id, data,t) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.addInventorySteps(inventory_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const getinventorychecklistAsync = (inventory_id, data,t) => async (dispatch) => {

  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getInventorychecklist(inventory_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      dispatch(setDashboardDetailsInventoryChecklistData(response));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const getinventoryPartialAnswersAsync = (inventory_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsLoading())
  dispatch(setDashboardDetailsInventoryPartialAnswersData({}))
  try {
    const response = await dashboardDetailsService.getInventoryPartialAnswers(inventory_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      dispatch(setDashboardDetailsInventoryPartialAnswersData(response));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const addInventoryPartialAnswersAsync = (inventory_id, data,t) => async (dispatch) => {
  try {
    const response = await dashboardDetailsService.addInventoryPartialAnswers(inventory_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const getEvaluationPartialAnswersAsync = (workshop_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsLoading())
  dispatch(setDashboardDetailsEvaluationPartialAnswersData({}))
  try {
    const response = await dashboardDetailsService.getEvaluationPartialAnswer(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      dispatch(setDashboardDetailsEvaluationPartialAnswersData(response?.data));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const addEvaluationPartialAnswersAsync = (workshop_id, data,t) => async (dispatch) => {
  try {
    const response = await dashboardDetailsService.addEvaluationPartialAnswer(workshop_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const UpdateEvaluationAnswerPageAsync = (workshop_id, data,t) => async (dispatch) => {
  try {
    const response = await dashboardDetailsService.UpdateEvaluationAnswerPage(workshop_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const getFollowupPartialAnswersAsync = (followup_id,t) => async (dispatch) => {
  dispatch(setDashboardDetailsFollowupPartialAnswersData({}))
  dispatch(setDashboardDetailsLoading())
  try {
    const response = await dashboardDetailsService.getFollowupPartialAnswer(followup_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      dispatch(setDashboardDetailsFollowupPartialAnswersData(response?.data));
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const addFollowupPartialAnswersAsync = (followup_id, data,t) => async (dispatch) => {
  try {
    const response = await dashboardDetailsService.addFollowupPartialAnswer(followup_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

const UpdateFollowupAnswerPageAsync = (followup_id, data,t) => async (dispatch) => {
  try {
    const response = await dashboardDetailsService.UpdateFollowupAnswerPage(followup_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setDashboardDetailsError(response));
      return false ;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setDashboardDetailsError(response));
      return false;
    } else {
      dispatch(setDashboardDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setDashboardDetailsError(error));
    return false ;
  }
};

export const DashboardDetailsAction = {
  getInventoryDetailsAsync,
  addInventoryAnswerAsync,
  getInventoryResultsAsync,
  getEvaluationDetailsAsync,
  addEvaluationAnswerAsync,
  getEvaluationResultsAsync,
  getFollowupDetailsAsync,
  addFollowupAnswerAsync,
  getFollowupResultsAsync,
  updateInventoryChecklistAsync,
  addInventoryStepsAsync,
  getinventorychecklistAsync,
  getinventoryPartialAnswersAsync,
  addInventoryPartialAnswersAsync,
  getEvaluationPartialAnswersAsync,
  addEvaluationPartialAnswersAsync,
  UpdateEvaluationAnswerPageAsync,
  getFollowupPartialAnswersAsync,
  addFollowupPartialAnswersAsync,
  UpdateFollowupAnswerPageAsync
};
